<template lang="html">
    <report-section
        id="methods"
        title="Methods"
    >
        <h5 class="title header is-5">
            Modeling
        </h5>

        <p>
            The hydrologic model driving the {{ appTitle }} was produced following similar methods to those
            described in:
        </p>

        <p>
            Chapman A, Kerr B, Wilford D (2018) A water allocation decision-support model and tool for predictions in
            ungauged basins in northeast British Columbia. J Am Water Resour Assoc 54 (3): 676–693.
            <a
                href="https://doi.org/10.1111/1752-1688.12643"
                target="_blank"
            >
                https://doi.org/10.1111/1752-1688.12643
            </a>
        </p>

        <p>
            The {{ appTitle }} uses climate drivers from:
        </p>

        <p>
            ClimateWNA v4.72 Normal {{ modelInformation.climateDriverYears }}
        </p>

        <p>
            Calibration and validation was performed using hydrometric records which were selected based on length of
            record, seasonality, and other characteristics.
        </p>

        <p>
            Hydrometric stations used: {{ modelInformation.numWatersheds }}
        </p>

        <p>
            Annual model performance:
        </p>

        <div class="box">
            <p>Mean Error: {{ modelInformation.meanError }}%</p>
            <p>Median Error: {{ modelInformation.medianError }}%</p>
            <p>Mean Absolute Error: {{ modelInformation.meanAbsoluteError }}%</p>
            <p>% of stations within +/- 20%: {{ modelInformation.watershedsWithin20Percent }}%</p>
        </div>
    </report-section>
</template>

<script>
import sectionMixin from '@foundryspatial/report-section/mixin';

import { MODEL_INFORMATION } from '@/constants/model-information';

export default {
    name: 'MethodsSection',

    mixins: [
        sectionMixin,
    ],

    computed: {
        appTitle() {
            return process.env.VUE_APP_TITLE;
        },
        modelInformation() {
            return MODEL_INFORMATION;
        },
    },
};
</script>

<style lang="scss">
</style>
